import React, { Component } from "react";
import { PageHeader, Row, Col, Tag } from "antd";
import { REPORTES, SECCIONES } from "./definicionesReportes";
import "../cmms.css";

// Reportes del CMMS: tarjetas por seccion; cada una abre /panel/cmmsReportes/<clave>.
class ReportesCMMS extends Component {
    abrir = (r) => !r.deshabilitado && this.props.history.push(`/panel/cmmsReportes/${r.key}`);

    render() {
        return (
            <div className="cmms-pagina">
                <PageHeader title="Reportes" subTitle="CMMS" style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }} />
                {SECCIONES.map((seccion) => (
                    <div key={seccion} style={{ marginBottom: 16 }}>
                        <div className="cmms-seccion-reportes">{seccion}</div>
                        <Row gutter={[12, 12]}>
                            {REPORTES.filter((r) => r.seccion === seccion).map((r) => (
                                <Col key={r.key} xs={24} md={12} xl={8}>
                                    <div className={`cmms-tarjeta-reporte ${r.deshabilitado ? "deshabilitada" : ""}`} onClick={() => this.abrir(r)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && this.abrir(r)}>
                                        <div className="cmms-tarjeta-reporte-icono">{r.icono}</div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div className="cmms-tarjeta-reporte-titulo">{r.titulo}</div>
                                            <div className="cmms-tarjeta-reporte-desc">{r.descripcion}</div>
                                            <div style={{ marginTop: 6 }}>
                                                {r.deshabilitado ? <Tag color="default">{r.deshabilitado}</Tag> : <Tag>{r.origen}</Tag>}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
        );
    }
}

export default ReportesCMMS;
